
<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="indexItems"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
  >

    <template slot="filterText1">
      <v-card style="margin: 10px;">
        <v-text-field
          style="padding: 16px 16px;"
          v-model="sellerNames"
          label="Vendedor"
        >
        </v-text-field>
      </v-card>
    </template>

    <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <New
        @entry-created="entryCreated"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

     <template slot="tableFooter">
      <tr class="d-none d-md-table-row">
        <td colspan="3" class="text-right"><strong class="title mx-3">Total: </strong></td>
        <td colspan="3" class="text-left title"><strong>{{ this.totalValue | formatCurrency }}</strong></td>
      </tr>
      <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Total: </div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.totalValue | formatCurrency }}</strong></div>
        </td>
      </tr>
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from '@shared_components/base_index.vue';
import New from "./new.vue";
import Edit from "./edit_copy.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      indexItems: [],
      loading: true,
      pageLoading: false,
      totalItems: 0,
      totalValue: 0,
      sellerNames: null,
      // tableHeaders: [],
      maskFields: [
        { field: 'itensTotalPrice', mask: 'currency'},
      ],
      infoHeaders: [],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Meta"
    },
    modelNamePlural: {
      type: String,
      default: "Metas"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  created() {
    // this.loadServerEntries();
  },
  watch: {
    "sellerNames": function(newSearch) {
      if (this.sellerNames && this.sellerNames.length > 0) {
        if (newSearch.length >= 3) {
          if(this.timer){
            clearTimeout(this.timer);
          }
          this.timer = setTimeout( ()=> {
            // console.log("newSearch", newSearch); 
            this.loadServerEntries();
          }, 2000);
        }
      }else{
        if(this.timer){
          clearTimeout(this.timer);
        }
        this.loadServerEntries();
      }
    },
  },
  computed: {
    tableHeaders() {
      return [
        { text: "Safra", align: "left", sortable: true, value: "harvestName" },
        { text: "Cliente", align: "left", sortable: true, value: "customerName" },
        { text: "Vendedor", align: "left", sortable: true, value: "sellerName" },
        { text: "Preço", align: "left", sortable: true, value: "itensTotalPrice" },
        // { text: "Ramo de atividade", align: "left", sortable: false, value: "businessActivity.name" },
        ... this.$can('create', this.$router.currentRoute.name) || this.$can('update', this.$router.currentRoute.name) ? [{ text: "Ações", align: "left", sortable: false, value: "action" }] : []
      ]
    }
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_GOAL,
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
              filters: this.filters,
              customFilters: {seller_name: this.sellerNames},
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.indexItems = response.data.accountContext.goalsIndex.goalViewIndexFilters; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
          this.totalItems = response.data.accountContext.goalsIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.totalValue = response.data.accountContext.goalsIndex.totalValue;
          this.typeOperators = response.data.accountContext.goalsIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.accountContext.goalsIndex.serverFields; // seta os campos que podem ser filtrados
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
  }
};

const LOAD_ALL_GOAL = gql `
  query($input: IndexInputObject!) {
    accountContext {
      goalsIndex(input: $input){
        count
        typeOperators
        serverFields
        totalValue
        goalViewIndexFilters {
          harvestName
          harvestId
          customerName
          sellerName
          itensTotalPrice
          customerId
          canBeDeleted
          undeletabilityReasons
        }
      }
    }
  }
`;

</script>

<style scoped></style>

